import React from 'react';

const Background: React.FC = () => {
    return (
        <div className="background">
            {/* 这里放置背景元素 */}
        </div>
    );
};

export default Background;